import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { KI_SPERRTEXT_KEYS, KiEntwurfUebernahme } from '../models/ki.model';
import { KiStatusService } from './ki-status.service';

const BEREITS_UEBERNOMMEN = 'KI_ENTWURF_BEREITS_UEBERNOMMEN';
const FEHLGESCHLAGEN = 'ki.entwurfKarte.uebernehmenFehler';

/** Übernahme eines KI-Testfall-Entwurfs als Testfall an der Anforderung (NEX-1536). */
@Injectable({ providedIn: 'root' })
export class KiEntwurfService {
  private readonly http = inject(HttpClient);
  private readonly kiStatus = inject(KiStatusService);
  private readonly base = `${environment.apiBaseUrl}/api/v1/projects`;

  /** Ohne `titel` übernimmt das Backend den Titel des gespeicherten Entwurfs. */
  uebernehmen(
    projectId: string,
    requirementId: string,
    entwurfId: string,
    anfrageId: string,
    titel?: string,
  ): Observable<KiEntwurfUebernahme> {
    const url =
      `${this.base}/${encodeURIComponent(projectId)}/requirements/${encodeURIComponent(requirementId)}` +
      `/ki/entwuerfe/${encodeURIComponent(entwurfId)}/uebernehmen`;
    const body = titel === undefined ? { anfrageId } : { anfrageId, titel };
    return this.http.post<{ testCaseId: string; key: string }>(url, body).pipe(
      map(({ testCaseId, key }): KiEntwurfUebernahme => ({ art: 'angelegt', testCaseId, key })),
      catchError((fehler: unknown) => of(this.abgelehnt(projectId, fehler))),
    );
  }

  /** 409 heißt „schon übernommen“; 403 sperrt die Testdesign-Funktionen wie beim Start einer Anfrage. */
  private abgelehnt(projectId: string, fehler: unknown): KiEntwurfUebernahme {
    if (fehler instanceof HttpErrorResponse) {
      if (fehler.status === 409 && fehler.error?.code === BEREITS_UEBERNOMMEN) return { art: 'bereitsUebernommen' };
      if (fehler.status === 403) {
        this.kiStatus.sperren(projectId, 'TESTDESIGN', 'rechte');
        return { art: 'fehler', textKey: KI_SPERRTEXT_KEYS.rechte, erneutMoeglich: false };
      }
    }
    return { art: 'fehler', textKey: FEHLGESCHLAGEN, erneutMoeglich: true };
  }
}
